// src/pages/Contact.js
import React from 'react';
import { FaPhone, FaWhatsapp, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="contact-hero-content">
          <h1>Entre em Contato</h1>
          <p>Estamos prontos para atender você</p>
        </div>
      </section>

      <div className="contact-container">
        {/* Informações de Contato */}
        <section className="contact-info-section">
          <div className="contact-grid">
            <div className="contact-card">
              <FaPhone className="contact-icon" />
              <h3>Telefone</h3>
              <p>(85) 99983-5383</p>
              <a href="tel:85999835383" className="contact-link">Ligar agora</a>
            </div>

            <div className="contact-card">
              <FaWhatsapp className="contact-icon" />
              <h3>WhatsApp</h3>
              <p>(85) 99983-5383</p>
              <a href="https://wa.me/5585999835383" target="_blank" rel="noopener noreferrer" className="contact-link">Enviar mensagem</a>
            </div>

            <div className="contact-card">
              <FaEnvelope className="contact-icon" />
              <h3>E-mail</h3>
              <p>g3rastreamento@gmail.com</p>
              <a href="mailto:g3rastreamento@gmail.com" className="contact-link">Enviar e-mail</a>
            </div>

            <div className="contact-card">
              <FaMapMarkerAlt className="contact-icon" />
              <h3>Endereço</h3>
              <p>Rua Barão de Vasconcelos, 632</p>
              <p>Rodolfo Teófilo - Fortaleza/CE</p>
              <p>CEP: 60430-420</p>
            </div>
          </div>
        </section>

        {/* Mapa */}
        <section className="map-section">
          <div className="map-container">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3981.2027923800157!2d-38.5557543!3d-3.7453296!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7c74907e3c739b7%3A0x9f8b3b53b31183b4!2sR.%20Bar%C3%A3o%20de%20Vasconcelos%2C%20632%20-%20Rodolfo%20Te%C3%B3filo%2C%20Fortaleza%20-%20CE%2C%2060430-420!5e0!3m2!1spt-BR!2sbr!4v1709324160799!5m2!1spt-BR!2sbr"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização G3 Rastreamento"
            ></iframe>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Contact;